import React from "react";
import RiskName from "../riskName/riskName";
import { RisksId } from "../../../../helpers/risk";
import { CalculateStore } from "../../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import TextInput from "../../../sharedComponents/textInput/textInput";
import DropDown from "../../../sharedComponents/dropDown/dropDown";
import { OcGuaranteeSumDropDown } from "../../../../helpers/oc";
import { SimpleAddressClass, SimpleAddressId } from "../../../../helpers/address";
import ZipCodeField from "../../../sharedComponents/address/addressField/zipCodeField";
import Header from "../../../sharedComponents/header/header";
import { ReactComponent as OcInPrivateLife } from "../../../../statics/icons/oc_in_private_life.svg";
import { displayAdditionalRiskForm, RisksNetworkTypes } from "../../../../helpers/risksNetwork";
import {NewLabel} from "../../../sharedComponents/newLabel/newLabel";

interface OcProps {
  calculateStore?: CalculateStore;
}

@inject("calculateStore")
@observer
export default class Oc extends React.Component<OcProps, any> {
  public render() {
    const calculateStore = this.props.calculateStore!;
    const shouldRenderOcWithoutProperty = calculateStore.oc;
    const ocDisabled = calculateStore.additionalInsurances.ocStandard.risksNetworkValue === RisksNetworkTypes.notAvailable;

    return (
      <div className="section oc">
        <div className={`oc-header ${ocDisabled ? "disabled" : ""}`}>
          <OcInPrivateLife className="icon-svg-color" />
          <Header type="small" mainHeader="OC w życiu prywatnym" />
        </div>
        <div className="oc-content">
          {shouldRenderOcWithoutProperty && this.renderOcWithoutProperty()}
          {this.renderOcStandard()}
          {this.renderOcAdditionalProperty()}
          {this.renderOcChildExtension()}
          {this.renderOcRenterExtension()}
        </div>
      </div>
    );
  }

  renderOcWithoutProperty() {
    const calculateStore = this.props.calculateStore!;

    return (
      <div className="oc-without-property">
        <RiskName riskId={RisksId.ocWithoutProperty}
          displayIcon={false}
          required={true}
          checkboxOnChange={(event) => {
            calculateStore.setAdditionalInsuranceFieldChecked(RisksId.ocWithoutProperty, event.target.checked);
            calculateStore.setPropertyInsurance(!event.target.checked);
          }}
        />
      </div>
    );
  }

  renderOcStandard() {
    const calculateStore = this.props.calculateStore!;
    const ocStandard = calculateStore.additionalInsurances.ocStandard;
    const displayForm = displayAdditionalRiskForm(calculateStore.additionalInsurances.ocStandard);

    return (
      <div className="oc-standard">
        <RiskName riskId={RisksId.ocStandard}
          displayIcon={false}
          checkboxOnChange={(event) => {
            calculateStore.setAdditionalInsuranceFieldChecked(RisksId.ocStandard, event.target.checked);

            if (event.target.checked === false) {
              calculateStore.setAdditionalInsuranceFieldChecked(RisksId.ocAdditionalProperty, false);
              calculateStore.setAdditionalInsuranceFieldChecked(RisksId.ocChildExtension, false);
              calculateStore.setAdditionalInsuranceFieldChecked(RisksId.ocRenterExtension, false);
            }
          }}
        />

        {displayForm && (
          <div className="oc-standard-value">
            <DropDown value={ocStandard.ocGuaranteeSum}
              items={OcGuaranteeSumDropDown}
              onChange={(value) => {
                calculateStore.setOcStandard(value);
              }}
              topLabel="Suma ubezpieczenia (zł)"
            />
            <TextInput
              disabled={true}
              className="rate"
              value={ocStandard.rate || "?"}
              topLabel="Składka (zł)"
            />
          </div>
        )}
      </div>
    );
  }

  renderOcAdditionalProperty() {
    const calculateStore = this.props.calculateStore!;
    const ocAdditionalProperty = calculateStore.additionalInsurances.ocAdditionalProperty;
    const displayForm = displayAdditionalRiskForm(ocAdditionalProperty);

    return (
      <div className="oc-additional-property">
        <div className="oc-additional-property-risk">
          <RiskName riskId={RisksId.ocAdditionalProperty}
            displayIcon={false}
            available={this.isOcExtensionsAvailable()}
            infoMessage={this.ocStandardNotification(ocAdditionalProperty.risksNetworkValue)}
            checkboxOnChange={(event) => {
              calculateStore.setAdditionalInsuranceFieldChecked(RisksId.ocAdditionalProperty, event.target.checked);
              ocAdditionalProperty.address.clearErrorMessages();
            }}
          >
          </RiskName>
          {displayForm && (
            <TextInput
              disabled={true}
              className="rate"
              value={ocAdditionalProperty.rate || "?"}
              topLabel="Składka (zł)"
            />
          )}
        </div>
        {displayForm && (
          <>
            <div className="address">
              <ZipCodeField value={ocAdditionalProperty.address.zipCode}
                onChange={(event) => {
                  calculateStore.setOcAdditionalPropertyAddress(SimpleAddressId.zipCode, event.target.value);
                }}
              />

              <TextInput className="city"
                topLabel={SimpleAddressClass.displayName.city}
                validatedValue={ocAdditionalProperty.address.city}
                onChange={(value) => {
                  calculateStore.setOcAdditionalPropertyAddress(SimpleAddressId.city, value);
                }}
              />

              <TextInput className="street"
                topLabel={SimpleAddressClass.displayName.street}
                validatedValue={ocAdditionalProperty.address.street}
                onChange={(value) => {
                  calculateStore.setOcAdditionalPropertyAddress(SimpleAddressId.street, value);
                }}
              />

              <TextInput className="buildingAndApartmentNumber"
                topLabel={SimpleAddressClass.displayName.buildingAndApartmentNumber}
                validatedValue={ocAdditionalProperty.address.buildingAndApartmentNumber}
                onChange={(value) => {
                  calculateStore.setOcAdditionalPropertyAddress(SimpleAddressId.buildingAndApartmentNumber, value);
                }}
              />
            </div>
          </>
        )}
      </div>
    );
  }

    renderOcChildExtension() {
        const calculateStore = this.props.calculateStore!;
        const ocChildExtension = calculateStore.additionalInsurances.ocChildExtension;
        const displayForm = displayAdditionalRiskForm(ocChildExtension);

        return (
            <div className="oc-active-extension">
                <div className="label">
                    <RiskName riskId={RisksId.ocChildExtension}
                              displayIcon={false}
                              available={this.isOcExtensionsAvailable()}
                              infoMessage={this.ocStandardNotification(ocChildExtension.risksNetworkValue)}
                              checkboxOnChange={(event) => {
                                  calculateStore.setAdditionalInsuranceFieldChecked(RisksId.ocChildExtension, event.target.checked);
                              }}
                    />
                    {this.isOcExtensionsAvailable() && <NewLabel/>}
                </div>

                {displayForm && (
                    <TextInput
                        disabled={true}
                        className="rate"
                        value={ocChildExtension.rate || "?"}
                        topLabel="Składka (zł)"
                    />
                )}
            </div>
        );
    }

  renderOcRenterExtension() {
    const calculateStore = this.props.calculateStore!;
    const ocRenterExtension = calculateStore.additionalInsurances.ocRenterExtension;
    const displayForm = displayAdditionalRiskForm(ocRenterExtension);

    return (
      <div className="oc-renter-extension">
        <RiskName riskId={RisksId.ocRenterExtension}
          displayIcon={false}
          available={this.isOcExtensionsAvailable()}
          infoMessage={this.ocStandardNotification(ocRenterExtension.risksNetworkValue)}
          checkboxOnChange={(event) => {
            calculateStore.setAdditionalInsuranceFieldChecked(RisksId.ocRenterExtension, event.target.checked);
          }}
        />

        {displayForm && (
          <TextInput
            disabled={true}
            className="rate"
            value={ocRenterExtension.rate || "?"}
            topLabel="Składka (zł)"
          />
        )}
      </div>
    );
  }

  private ocStandardNotification(risksNetworkValue: RisksNetworkTypes | undefined) {
    const ocStandard = this.props.calculateStore!.additionalInsurances.ocStandard;
    const ocStandardChecked = ocStandard.checked;
    const ocStandardRequired = ocStandard.risksNetworkValue === RisksNetworkTypes.required;
    const ocStandardAvailable = ocStandard.risksNetworkValue === RisksNetworkTypes.available || ocStandard.risksNetworkValue === undefined;
    // @ts-ignore
    const riskAvailable = risksNetworkValue === RisksNetworkTypes.available || risksNetworkValue === undefined;

    if (!ocStandardChecked && !ocStandardRequired && ocStandardAvailable && riskAvailable) {
      return "Dostępne po wybraniu OC w życiu prywatnym";
    }

    return "";
  }

  private isOcExtensionsAvailable() {
    const calculateStore = this.props.calculateStore!;
    const ocStandard = calculateStore.additionalInsurances.ocStandard;

    return (ocStandard.checked && ocStandard.risksNetworkValue === RisksNetworkTypes.available) ||
      ocStandard.risksNetworkValue === RisksNetworkTypes.required;
  }
}
